import React from 'react';
import AppStore from 'AppStore';

import * as Strings from '../../utils/strings';

import CustomButton from '../../common/components/CustomButton';
import CustomText from '../../common/components/CustomText';
import { getPortfolio } from './PortfolioActions';

import './Portfolio.scss';

export default class Portfolio extends React.Component {
    constructor() {
        super();
        this.state = { portfolio: null };
    }

    componentWillMount = () => {
        AppStore.on('portfolio_retrieved', this.onPortfolioRetrieved);
        this.profile = AppStore.getProfile();
        if (this.profile && this.profile.portalId) {
            const cb = () => {
                getPortfolio(this.profile.portalId);
            };
            setTimeout(cb, 500);
        } else {
            alert('Ops, something went wrong. Please refresh the page');
        }
    };

    componentWillUnmount = () => {
        AppStore.removeListener(
            'portfolio_retrieved',
            this.onPortfolioRetrieved
        );
    };
    onPortfolioRetrieved = () => {
        const portfolio = AppStore.getAppState().portfolio;
        this.setState({ portfolio: portfolio });
    };

    render() {
        if (!this.state.portfolio) {
            return (
                <div className="hack">
                    <div id="app-container">
                        <center>loading...</center>
                    </div>
                </div>
            );
        }
        // const payload = {
        //     leases: [
        //         {
        //             vendorName: 'Example Company',
        //             vendorInvoice: 60000.0,
        //             purchaseOptionDate: '2018-03-01',
        //             purchaseOptionAmount: 60.0,
        //             paymentBeforeTax: 8000.0,
        //             leaseStartDate: '2018-03-01',
        //             leaseNumber: 'L-002727',
        //             leaseId: 'a070x000000U1KwAAK',
        //             leaseEndDate: '2019-03-01',
        //             fullTerm: 12,
        //             assets: 'Agricultural;Air Compressor;Air Cleaning'
        //         },
        //         {
        //             vendorName: 'Example Company',
        //             vendorInvoice: 60000.0,
        //             purchaseOptionDate: '2018-03-01',
        //             purchaseOptionAmount: 60.0,
        //             paymentBeforeTax: 8000.0,
        //             leaseStartDate: '2018-03-01',
        //             leaseNumber: 'L-002727',
        //             leaseId: 'a070x000000U1KwAAK',
        //             leaseEndDate: '2019-03-01',
        //             fullTerm: 12,
        //             assets: 'Agricultural;Air Compressor;Air Cleaning'
        //         }
        //     ],
        //     creditApps: [
        //         {
        //             description: 'Fun stuff',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05803',
        //             creditAppId: 'a090x000001N843AAC',
        //             createdDate: '2018-02-07',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 20000.0
        //         },
        //         {
        //             description: 'Fun stuff',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05804',
        //             creditAppId: 'a090x000001N85BAAS',
        //             createdDate: '2018-02-07',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 20000.0
        //         },
        //         {
        //             description: 'Fun stuff',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05805',
        //             creditAppId: 'a090x000001N85GAAS',
        //             createdDate: '2018-02-07',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 20000.0
        //         },
        //         {
        //             description: 'Fun stuff',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05806',
        //             creditAppId: 'a090x000001N85LAAS',
        //             createdDate: '2018-02-07',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 20000.0
        //         },
        //         {
        //             description: 'Fun stuff',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05807',
        //             creditAppId: 'a090x000001N8YfAAK',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 20000.0
        //         },
        //         {
        //             description: 'Fun stuff',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05808',
        //             creditAppId: 'a090x000001N8YkAAK',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 20000.0
        //         },
        //         {
        //             description: 'fdsafdasfsad',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05812',
        //             creditAppId: 'a090x000001N8dUAAS',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 23432.0
        //         },
        //         {
        //             description: 'fdsafdasfsad',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05810',
        //             creditAppId: 'a090x000001N8dKAAS',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 23432.0
        //         },
        //         {
        //             description: 'fadfds',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05813',
        //             creditAppId: 'a090x000001N8dZAAS',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 123212.0
        //         },
        //         {
        //             description: 'fadsfdasfsa',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05814',
        //             creditAppId: 'a090x000001N8dyAAC',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 323223.0
        //         },
        //         {
        //             description: 'fadsfsad',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05815',
        //             creditAppId: 'a090x000001N8e3AAC',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 54.0
        //         },
        //         {
        //             description: 'fadsdsa',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05816',
        //             creditAppId: 'a090x000001N8e8AAC',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 3223.0
        //         },
        //         {
        //             description: 'fdsafdasfsad',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05811',
        //             creditAppId: 'a090x000001N8dPAAS',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 23432.0
        //         },
        //         {
        //             description: 'stuff',
        //             creditStatus: 'Pending - Sent for Approval',
        //             creditAppNumber: 'BK-05809',
        //             creditAppId: 'a090x000001N8dFAAS',
        //             createdDate: '2018-02-09',
        //             applicationStatus: 'UNK',
        //             applicationAmount: 323232.0
        //         }
        //     ]
        // };
        const payload = this.state.portfolio;
        const leaseList = payload.leases.map(lease => (
            <tr>
                <td>
                    <a href={'/portfolio/lease/' + lease.leaseId}>
                        {lease.leaseNumber}
                    </a>
                </td>
                <td>
                    <a href={'/portfolio/lease/' + lease.leaseId}>
                        {lease.assets}
                    </a>
                </td>
                <td>
                    <a href={'/portfolio/lease/' + lease.leaseId}>
                        {lease.lesseeName}
                    </a>
                </td>
            </tr>
        ));

        const creditList = payload.creditApps.map(creditApp => (
            <tr>
                <td>
                    <a href={'/portfolio/credit/' + creditApp.creditAppId}>
                        {creditApp.creditAppNumber}
                    </a>
                </td>
                <td>
                    <a href={'/portfolio/credit/' + creditApp.creditAppId}>
                        {creditApp.description}
                    </a>
                </td>
                <td>
                    <a href={'/portfolio/credit/' + creditApp.creditAppId}>
                        {creditApp.lesseeName}
                    </a>
                </td>
            </tr>
        ));
        return (
            <div className="hack">
                <div id="app-container">
                    <div id="quotes-container" className="form-container">
                        <div className="select-quote-options">
                            <h2>
                                <center>
                                    Your Funded Leases <br />
                                    (Click on Lease # to expand)
                                </center>
                            </h2>
                            <br />
                            <table>
                                <tr>
                                    <td
                                        style={{
                                            fontWeight: 500
                                        }}
                                    >
                                        Lease #
                                    </td>
                                    <td
                                        style={{
                                            fontWeight: 500
                                        }}
                                    >
                                        Asset description
                                    </td>
                                    <td
                                        style={{
                                            fontWeight: 500
                                        }}
                                    >
                                        Company Name
                                    </td>
                                </tr>
                                {leaseList}
                            </table>

                            <br />
                            <br />
                            <h2>
                                <center>
                                    Your Credit Applications<br />(Click on
                                    Application # to expand)
                                </center>
                            </h2>
                            <br />

                            <table>
                                <tr>
                                    <td
                                        style={{
                                            fontWeight: 500
                                        }}
                                    >
                                        Application #
                                    </td>
                                    <td
                                        style={{
                                            fontWeight: 500
                                        }}
                                    >
                                        Asset description
                                    </td>
                                    <td
                                        style={{
                                            fontWeight: 500
                                        }}
                                    >
                                        Company Name
                                    </td>
                                </tr>
                                {creditList}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/portfolio/Portfolio.jsx